import { Button } from "@material-tailwind/react";
import { Backdrop, Box, Fade, Modal } from "@mui/material";
import { IoClose } from "react-icons/io5";
import ReactSelect from "react-select";

function AssignBranches(props) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    padding: "40px",
    outline: "none",
    borderRadius: "35px",
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={props.open}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={props.open}>
          <Box sx={style}>
            <div className="flex justify-between items-center">
              <p className="font-bold text-4xl text-black">Assign Branches</p>
              <IoClose
                className="cursor-pointer border border-[#BDBDBD] rounded-full absolute right-6 top-8 text-[#BDBDBD]"
                onClick={props.onClose}
              />
            </div>
            <form
              onSubmit={props.handleAssignBatchSubmit}
              className="mt-3 w-[300px] sm:w-[400px] md:w-[600px] lg:w-[800px] flex flex-col gap-3"
            >
              <ReactSelect
                value={props.selectedValues}
                isMulti
                name="colors"
                options={props.options}
                onChange={(e) => {
                  props.setSelectedValues(e || []);
                  props.setFieldAssignBranch({
                    ...props.fieldAssignBranch,
                    list: e || [],
                  });
                }}
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    maxHeight: "50dvh",
                    overflowY: "auto",
                  }),
                  control: (provided) => ({
                    ...provided,
                    maxHeight: "50dvh",
                    overflowY: "auto",
                  }),
                }}
                className="basic-multi-select max-h-[50dvh]"
                classNamePrefix="select"
                closeMenuOnSelect={false}
                isClearable={false}
                // required
              />

              <div className="flex justify-end items-center">
                <Button
                  type="submit"
                  disabled={props.loading?.btn}
                  className="mt-2 rounded-xl bg-[#03438D] px-7 py-3 tracking-widest font-poppins font-light text-md outline-none"
                >
                  {props.loading?.btn ? "Assigning..." : "Assign"}
                </Button>
              </div>
            </form>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

export default AssignBranches;
